import { render, staticRenderFns } from "./VEmployerCompanyDocuments.vue?vue&type=template&id=1a35e193&lang=pug"
import script from "./VEmployerCompanyDocuments.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompanyDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports